<div class="modal-header">
  <h4 class="modal-title">{{_(KEYS.CRUD.CUSTOM_FIELD)}}</h4>
  <button type="button" class="close" (click)="activeModal.dismiss()">
    <i class="fa fa-close"></i>
  </button>
</div>

<div class="modal-body qa-crud animated fadeIn">
  <form>
    <!-- Label -->
    <div class="form-group">
      <label for="label">{{_(KEYS.CRUD.LABEL)}}</label>
      <div class="input-group">
        <span class="input-group-addon qa-icon-addon"><i class="fa fa-tag"></i></span>
        <input
          type="text"
          class="form-control"
          id="label"
          [(ngModel)]="label"
          [ngModelOptions]="{standalone: true}"
          [placeholder]="_(KEYS.CRUD.ENTER_LABEL)">
      </div>
    </div>

    <!-- Key -->
    <div class="form-group">
      <label for="key">{{_(KEYS.CRUD.KEY)}}</label>
      <div class="input-group">
        <span class="input-group-addon qa-icon-addon"><i class="fa fa-key"></i></span>
        <input
          type="text"
          class="form-control"
          id="key"
          [(ngModel)]="key"
          [ngModelOptions]="{standalone: true}"
          [placeholder]="_(KEYS.CRUD.ENTER_KEY)"
          [disabled]="isEditMode"
          [ngClass]="{'is-invalid': key && !isKeyValid()}"
          pattern="^[a-zA-Z][a-zA-Z0-9_]{0,63}$">
      </div>
      <small *ngIf="isEditMode" class="form-text text-muted">
        {{_(KEYS.CRUD.KEY_NOT_EDITABLE)}}
      </small>
      <small *ngIf="key && !isKeyValid() && !isEditMode" class="form-text text-danger">
        {{_(KEYS.CRUD.KEY_INVALID_HINT)}}
      </small>
    </div>

    <!-- Type -->
    <div class="form-group">
      <label for="type">{{_(KEYS.CRUD.TYPE)}}</label>
      <div class="input-group">
        <span class="input-group-addon qa-icon-addon"><i class="fa fa-list-alt"></i></span>
        <select
          class="form-control"
          id="type"
          [(ngModel)]="type"
          [ngModelOptions]="{standalone: true}"
          (change)="onTypeChange()">
          <option [ngValue]="null">{{_(KEYS.CRUD.SELECT_TYPE)}}</option>
          <option value="text">{{_(KEYS.CRUD.TYPE_TEXT)}}</option>
          <option value="number">{{_(KEYS.CRUD.TYPE_NUMBER)}}</option>
          <option value="date">{{_(KEYS.CRUD.TYPE_DATE)}}</option>
          <option value="select">{{_(KEYS.CRUD.TYPE_SELECT)}}</option>
          <option value="boolean">{{_(KEYS.CRUD.TYPE_BOOLEAN)}}</option>
        </select>
      </div>
    </div>

    <!-- Required Field -->
    <div class="form-group">
      <label for="required">{{_(KEYS.CRUD.REQUIRED_FIELD)}}</label>
      <div class="input-group">
        <span class="input-group-addon qa-icon-addon"><i class="fa fa-asterisk"></i></span>
        <select
          class="form-control"
          id="required"
          [(ngModel)]="required"
          [ngModelOptions]="{standalone: true}">
          <option [ngValue]="false">{{_(KEYS.CRUD.NO)}}</option>
          <option [ngValue]="true">{{_(KEYS.CRUD.YES)}}</option>
        </select>
      </div>
    </div>

    <!-- Options (only for select type) -->
    <div class="form-group" *ngIf="type === 'select'">
      <label class="d-block">{{_(KEYS.CRUD.OPTIONS)}}</label>
      <div *ngFor="let option of options; let i = index" class="input-group mb-2">
        <span class="input-group-addon qa-icon-addon"><i class="fa fa-list-ul"></i></span>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="option.value"
          (ngModelChange)="onOptionChange(option)"
          [ngModelOptions]="{standalone: true}"
          [placeholder]="_(KEYS.CRUD.OPTION_VALUE)">
        <div class="input-group-append">
          <button class="btn btn-danger" type="button" (click)="removeOption(i)" [title]="_(KEYS.CRUD.REMOVE_OPTION)">
            <i class="fa fa-trash"></i>
          </button>
        </div>
      </div>
      <button class="btn btn-secondary btn-sm" [ngClass]="{'mt-2': options.length === 0}" type="button" (click)="addOption()">
        <i class="fa fa-plus"></i> {{_(KEYS.CRUD.ADD_OPTION)}}
      </button>
    </div>

    <!-- Validation (regex only for text type) -->
    <div class="form-group" *ngIf="type === 'text'">
      <label>{{_(KEYS.CRUD.VALIDATION)}}</label>
      <div class="input-group mb-2">
        <span class="input-group-addon qa-icon-addon"><i class="fa fa-random"></i></span>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="validation.regex"
          [ngModelOptions]="{standalone: true}"
          [placeholder]="_(KEYS.CRUD.REGULAR_EXPRESSION)"
          [ngClass]="{'is-invalid': validation.regex && !isRegexValid()}">
        <input
          type="text"
          class="form-control qa-regex-mod"
          [(ngModel)]="validation.regexMod"
          [ngModelOptions]="{standalone: true}"
          [placeholder]="_(KEYS.CRUD.REGEX_MODIFIER)">
      </div>
      <small *ngIf="validation.regex && !isRegexValid()" class="text-danger">
        {{_(KEYS.CRUD.INVALID_REGEX)}}
      </small>
      <div class="input-group mt-2">
        <span class="input-group-addon qa-icon-addon"><i class="fa fa-lightbulb-o"></i></span>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="validation.hint"
          [ngModelOptions]="{standalone: true}"
          [placeholder]="_(KEYS.CRUD.HINT)">
      </div>
    </div>

    <!-- Hint (for non-text types when required) -->
    <div class="form-group" *ngIf="type !== 'text' && required">
      <label>{{_(KEYS.CRUD.HINT)}}</label>
      <div class="input-group">
        <span class="input-group-addon qa-icon-addon"><i class="fa fa-lightbulb-o"></i></span>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="validation.hint"
          [ngModelOptions]="{standalone: true}"
          [placeholder]="_(KEYS.CRUD.HINT)">
      </div>
    </div>
  </form>
</div>

<div class="modal-footer">
  <button type="button" class="btn btn-secondary" (click)="onCancel()">
    <i class="fa fa-close"></i>
    {{_(KEYS.CRUD.CANCEL)}}
  </button>
  <button type="button" class="btn btn-primary" (click)="onSave()" [attr.disabled]="canSave() ? null : true">
    <i class="fa fa-save"></i>
    {{_(KEYS.CRUD.SAVE)}}
  </button>
</div>
